module.exports = __webpack_public_path__ + "img/image_21.df83f959.png";